import { Box, Flex, Stack } from '@chakra-ui/react';
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';

function SidebarContent(props: { routes: RoutesType[], onClose?: () => void, isCollapsed?: boolean }) {
	const { routes, onClose, isCollapsed } = props;

	// SIDEBAR
	return (
		<Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
			<Brand isCollapsed={isCollapsed} />
			<Stack direction='column' mt='8px' mb='auto'>
				<Box ps={isCollapsed ? '0px' : '9px'} pt='50px' pe={isCollapsed ? '0px' : { lg: '16px', '2xl': '16px' }}>
					<Links routes={routes} onClose={onClose} isCollapsed={isCollapsed} />
				</Box>
			</Stack>
			<Box ps={isCollapsed ? '10px' : '20px'} pe={isCollapsed ? '10px' : { lg: '16px', '2xl': '20px' }} mt='60px' mb='40px' borderRadius='30px'>
				<SidebarCard onClose={onClose} isCollapsed={isCollapsed} />
			</Box>
		</Flex>
	);
}

export default SidebarContent;
